import axios from './index';

import type { ApiResponse } from './dramas';

export type AppVersionUpdateType = 'Remind' | 'Force' | 'RemindOnly';
export type AppVersionUpdateStatus = 'Enabled' | 'Disabled';
export type AppVersionChannel = 'ios' | 'android' | 'apk';

export interface AppVersionChannelConfig {
    version_name: string;
    download_url: string;
}

export interface AppVersionContents {
    zh: string;
    en: string;
    ja?: string;
    es?: string;
    vi?: string;
    tr?: string;
}

export interface AppVersionUpdatePayload {
    type: AppVersionUpdateType;
    ios?: AppVersionChannelConfig;
    android?: AppVersionChannelConfig;
    apk?: AppVersionChannelConfig;
    contents: AppVersionContents;
}

export interface AppVersionUpdateItem {
    id: string;
    type: AppVersionUpdateType;
    status: AppVersionUpdateStatus;
    publisher_account_id?: string;
    publisher_account?: string;
    ios_version_name?: string | null;
    ios_download_url?: string | null;
    android_version_name?: string | null;
    android_download_url?: string | null;
    apk_version_name?: string | null;
    apk_download_url?: string | null;
    contents?: AppVersionContents;
    created_at?: string;
    updated_at?: string;
}

export interface AppVersionUpdateListParams {
    page?: number;
    size?: number;
    type?: AppVersionUpdateType;
    status?: AppVersionUpdateStatus;
    channel?: AppVersionChannel;
    created_at?: [string, string];
}

export interface PaginatedMeta {
    cursor?: string;
    more?: boolean;
    page?: number;
    size?: number;
    total?: number;
}

export type AppVersionUpdateListResponse = ApiResponse<AppVersionUpdateItem[]> & {
    meta?: PaginatedMeta;
};

export type AppVersionUpdateDetailResponse = ApiResponse<AppVersionUpdateItem>;

export const appVersionUpdateList = (params?: AppVersionUpdateListParams) => {
    return axios<AppVersionUpdateListResponse>('/v1/app-version-updates', {
        method: 'get',
        params,
    });
};

export const appVersionUpdateDetail = (id: string) => {
    return axios<AppVersionUpdateDetailResponse>(`/v1/app-version-updates/${id}`, {
        method: 'get',
    });
};

export const appVersionUpdateCreate = (data: AppVersionUpdatePayload) => {
    return axios<AppVersionUpdateDetailResponse>('/v1/app-version-updates', {
        method: 'post',
        data,
    });
};

export const appVersionUpdatePatch = (id: string, data: AppVersionUpdatePayload) => {
    return axios<AppVersionUpdateDetailResponse>(`/v1/app-version-updates/${id}`, {
        method: 'patch',
        data,
    });
};

export const appVersionUpdateDisable = (id: string) => {
    return axios<AppVersionUpdateDetailResponse>(`/v1/app-version-updates/${id}/disable`, {
        method: 'post',
    });
};

export const appVersionUpdateEnable = (id: string) => {
    return axios<AppVersionUpdateDetailResponse>(`/v1/app-version-updates/${id}/enable`, {
        method: 'post',
    });
};
